module.exports = __webpack_public_path__ + "img/236.6f96e239.jpg";